import { FC, MouseEventHandler } from 'react'
import { Typography, ButtonBase, Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import makeStyles from '@mui/styles/makeStyles';
import { DeloittePaper } from './DeloittePaper';

interface DeloitteOfferProps {
    label: string,
    icon: any,
    onClick?: MouseEventHandler
}
const useStyles = makeStyles(theme => ({
    icon: {
        fontSize: '60px'
    },
    typo: {
        fontSize: '18px',
        lineHeight: '30px'
    },

    root: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        alignItems: 'stretch',
        height: '100%'
    },
    button: {
        display: 'flex',
        flexGrow: 1
    }
}));

export const DeloitteOffer: FC<DeloitteOfferProps> = (props) => {
    const { icon, label, onClick } = props;
    const Icon = icon;
    const classes = useStyles();
    return (
        <Box className={classes.root}>
            <ButtonBase
                focusRipple
                className={classes.button}
                onClick={onClick}
            >
                <DeloittePaper fullHeight elevation={2} style={{ minHeight: '155px' }}>
                    <Grid container direction="row" alignItems="center" style={{ height: "100%" }}>
                        <Grid xs={4}>
                            <Icon className={classes.icon} />
                        </Grid>
                        <Grid xs={8}>
                            <Typography className={classes.typo}>{label}</Typography>
                        </Grid>
                    </Grid>
                </DeloittePaper>
            </ButtonBase>
        </Box>
    )
}